import { mapGetters } from "vuex";

export default {
    name: "PigmentCodeList",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "pigmentCode/content",
      })
    },
    methods: {
      scroll() {
        const element = document.querySelector(".pigment-code__format--title")
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
            offset: { top: 30 }
          })
        }
      }
    }
}
